import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import moment from 'moment';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import StatusIcon from 'modules/common/components/StatusIcon';
import { ordinalSuffixFormatter } from '../../../../../../helper';
import ViewFeesModal from '../modals/ViewFeesModal';
import * as actions from '../action';
import './PermitApplication.css';

function PermitApplication({
  permitApplication,
  handleRemove,
  handleRevokeBusinessPermit,
  isLoading,
  businessId,
  handleRevokeBarangayClearance,
  isLoadingBarangayClearance,
}) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleViewFees = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <ViewFeesModal
          businessId={businessId}
          applicationId={data.id}
          feesInfo={data}
        />
      ),
      title: 'View Fees',
      modalSize: 'modal-xl',
    });
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        {!_.isEmpty(permitApplication) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  {permitApplication.map((item) => {
                    const terms =
                      _.get(item, 'attributes.qtr_from') ===
                        _.get(item, 'attributes.qtr_to') ||
                      _.get(item, 'attributes.qtr_from') === 0 ||
                      _.get(item, 'attributes.qtr_from') === null
                        ? ordinalSuffixFormatter(
                            _.get(item, 'attributes.qtr_to')
                          )
                        : `${ordinalSuffixFormatter(
                            _.get(item, 'attributes.qtr_from')
                          )} - ${ordinalSuffixFormatter(
                            _.get(item, 'attributes.qtr_to')
                          )}`;

                    // const barangayClearanceIssuedRevoked =
                    //   ['ISSUED', 'REVOKED'].indexOf(
                    //     _.get(item, 'attributes.status')
                    //   ) > -1;
                    const withBarangayClearance = _.get(
                      item,
                      'attributes.with_barangay_clearance'
                    );
                    // const isRevokedBarangayClearance = _.get(
                    //   item,
                    //   'attributes.brgy_clearance_revoked_at'
                    // );
                    const newRenewalTransactions =
                      ['NEW', 'RENEWAL'].indexOf(
                        _.get(item, 'attributes.type')
                      ) > -1;
                    
                    // const barangayClearanceStatus = () => {
                    //   if (
                    //     !barangayClearanceIssuedRevoked &&
                    //     withBarangayClearance
                    //   ) {
                    //     return 'REQUESTED';
                    //   }
                    //   if (
                    //     !barangayClearanceIssuedRevoked &&
                    //     !withBarangayClearance
                    //   ) {
                    //     return 'NOT AVAILABLE';
                    //   }
                    //   if (
                    //     barangayClearanceIssuedRevoked &&
                    //     !withBarangayClearance
                    //   ) {
                    //     return 'NOT AVAILABLE';
                    //   }
                    //   if (
                    //     barangayClearanceIssuedRevoked &&
                    //     withBarangayClearance &&
                    //     isRevokedBarangayClearance
                    //   ) {
                    //     return 'REVOKED';
                    //   }
                    //   if (
                    //     barangayClearanceIssuedRevoked &&
                    //     withBarangayClearance &&
                    //     !isRevokedBarangayClearance
                    //   ) {
                    //     return 'ISSUED';
                    //   }
                    //   return null;
                    // };

                    return (
                      <div key={item.id}>
                        <table className="transaction-table table table-borderless table-sm ">
                          <tbody>
                            <tr>
                              <td width="350" colSpan={6}>
                                <div className="d-flex justify-content-between align-items-center">
                                  <span
                                    className="title"
                                    style={{ fontSize: '16px' }}
                                  >
                                    BUSINESS APPLICATION
                                  </span>
                                  <div
                                    className="d-flex"
                                    style={{ gap: '.5rem' }}
                                  >
                                    {['ISSUED', 'REVOKED'].indexOf(
                                      _.get(item, 'attributes.status')
                                    ) > -1 &&
                                      Acl(permissions, [
                                        'REVOKE BARANGAY CLEARANCE',
                                      ]) &&
                                      Boolean(withBarangayClearance) && (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleRevokeBarangayClearance(item)
                                          }
                                          className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                                          disabled={isLoadingBarangayClearance}
                                        >
                                          {_.get(item, 'attributes.is_revoked')
                                            ? 'Unrevoked Barangay Business Clearance'
                                            : 'Revoke Barangay Business Clearance'}
                                        </button>
                                      )}
                                    {['ISSUED', 'REVOKED'].indexOf(
                                      _.get(item, 'attributes.status')
                                    ) > -1 &&
                                      Acl(permissions, [
                                        'REVOKE BUSINESS PERMIT',
                                      ]) && (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleRevokeBusinessPermit(item)
                                          }
                                          className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                                          disabled={isLoading}
                                        >
                                          {_.get(item, 'attributes.is_revoked')
                                            ? 'Unrevoked Permit'
                                            : 'Revoke Permit'}
                                        </button>
                                      )}
                                    <button
                                      type="button"
                                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                                      onClick={handleViewFees(item)}
                                    >
                                      View Fees
                                    </button>
                                    {_.get(item, 'attributes.is_imported') ? (
                                      <button
                                        type="button"
                                        className="border-0 p-2 button-custom"
                                        onClick={() => handleRemove(item.id)}
                                      >
                                        <i className="fa fa-trash" />
                                      </button>
                                    ) : null}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Application Type
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.type')}</b>
                              </td>
                            </tr>
                            {newRenewalTransactions ? (
                              <tr>
                                <td className="text-dark" width="350">
                                  Barangay Business Clearance Status
                                </td>
                                <td className="text-dark" width="1">
                                  :
                                </td>
                                <td colSpan={4}>
                                  <b>
                                    <StatusIcon
                                      value={
                                        _.get(
                                          item,
                                          'attributes.barangay_clearance_status'
                                        ) || '-'
                                      }
                                    />
                                  </b>
                                </td>
                              </tr>
                            ) : null}
                            <tr>
                              <td className="text-dark" width="350">
                                BPLS Status
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(item, 'attributes.status') === 'PAID'
                                    ? 'FOR PRINTING'
                                    : _.get(item, 'attributes.status')}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Year
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.year')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Application Date
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.date_human')}</b>
                              </td>
                            </tr>
                            {_.get(item, 'attributes.type') === 'RETIREMENT' ? (
                              <React.Fragment>
                                <tr>
                                  <td className="text-dark" width="350">
                                    Actual Closure Date
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(item, 'attributes.closure_date') ? moment(_.get(item, 'attributes.closure_date')).format(
                                        'MMMM D, YYYY'
                                      ) : ''}
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-dark" width="350">
                                    Retirement Reason
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td colSpan={4}>
                                    <b>
                                      {_.get(item, 'attributes.closure_reason', '')}
                                    </b>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ) : ''}
                            <tr>
                              <td className="text-dark" width="350">
                                Amount
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.amount_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Discount
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(item, 'attributes.discount_human')}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Surcharge
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(item, 'attributes.surcharge_human')}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Interest
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(item, 'attributes.interest_human')}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Total
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.total_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Term
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{terms}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                E-SOA Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.e_soa_no')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                OR Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.or_no')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                OR Date
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.or_date_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Permit Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.e_permit_no')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Issued Date
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.issued_date_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Valid Until
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>{_.get(item, 'attributes.valid_until_human')}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Barangay Business Clearance Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    item,
                                    'attributes.barangay_clearance_number'
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Business Plate Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    item,
                                    'attributes.business_plate_number'
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="350">
                                Source Type
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td colSpan={4}>
                                <b>
                                  {_.get(
                                    item,
                                    'attributes.source_type'
                                  )}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <hr />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

PermitApplication.propTypes = {
  permitApplication: PropTypes.instanceOf(Object).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleRevokeBusinessPermit: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  businessId: PropTypes.string.isRequired,
  handleRevokeBarangayClearance: PropTypes.instanceOf(Function).isRequired,
  isLoadingBarangayClearance: PropTypes.bool.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PermitApplication);
